import { inject } from '@angular/core'
import { CanActivateFn } from '@angular/router'
import { StateService } from '../services/state.service'

export const languageGuard: CanActivateFn = (route, state) => {
  const stateService = inject(StateService)
  const slug = route.paramMap.get('slug')

  if (stateService.isStateFromStorage()) {
    return true
  }

  if (slug) {
    const allArticles = stateService.state().articles
    const targetArticle = allArticles.find((a) => a.slug === slug)

    if (targetArticle && targetArticle.language && targetArticle.language !== stateService.currentLanguage()) {
      stateService.setCurrentLanguage(targetArticle.language)
    }
  }

  return true
}
